export class IEngine {
    constructor(sequence) {
        this.sequence = sequence;
    }
}
//# sourceMappingURL=engine.js.map